import { useLocation } from "react-router-dom";

import { CancelledShiftDetailsPage } from "./CancelledShiftDetails/Page";
import { ShiftDetailsPage } from "./ShiftDetails/Page";

export function ShiftDetailsRoute() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isCancelled = searchParams.get("cancelled") === "true";

  return isCancelled ? <CancelledShiftDetailsPage /> : <ShiftDetailsPage />;
}
